// @ts-nocheck
import { getMessagesDataView } from "@insite/client-framework/Store/Data/Messages/MessagesSelector";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";

export const useMessagesDataView = convertSelectorToHook(getMessagesDataView);
